import React, { useState } from "react";
import { Button, Tooltip } from "antd";
import { LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "../../../../utils/common";

const OpenTicket = (props: any) => {
  const { onSubmit } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Tooltip title="Przywróć wątek">
      <Button
        icon={isLoading ? <LoadingOutlined spin /> : <ReloadOutlined />}
        onClick={() => {
          setIsLoading(true);
          onSubmit(
            {
              open: true,
            },
            () => {
              openNotificationWithIcon("success", "Wątek przywrócony.");
              setIsLoading(false);
            },
            () => setIsLoading(false)
          );
        }}
      />
    </Tooltip>
  );
};

export default OpenTicket;
